import { render, staticRenderFns } from "./ExamObject.vue?vue&type=template&id=280e74e2&scoped=true&"
import script from "./ExamObject.vue?vue&type=script&lang=js&"
export * from "./ExamObject.vue?vue&type=script&lang=js&"
import style0 from "./ExamObject.vue?vue&type=style&index=0&id=280e74e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e74e2",
  null
  
)

export default component.exports